// Reserve a height here. Helps preserve consistency and no
// z-index values are duplicated.

const zIndex = {
  modal: 1000,
  anchoredDiv: 9997,
  tooltip: 9998,
  toast: 9999,
};

export default zIndex;
